<template>
    <v-card>
        <h1 class="text-pagename text-xs-center">Request credit</h1>
        <requestCredit/>
    </v-card>
</template>

<script>

import requestCredit from '@/components/back-office/Rider/RequestCredit/RequestCreditTable'
    export default {
        data() {
            return {
            }
        },
        components: {
            requestCredit
        },
        mounted() {
            const path = [{
                    text: 'Select province',
                    disabled: false,
                    href:  "/weserve_admin_login/select/"
                },
                {
                    text: 'Select service',
                    disabled: false,
                    href: '/weserve_admin_login/control/' + this.$route.params.province
                }, 
                {
                    text: 'Rider',
                    disabled: false,
                    href: '/weserve_admin_login/control/' + this.$route.params.province + '/rider/riderinhouse'
                    // href: '/weserve_admin_login/control/' + this.$route.params.province + '/rider/riderdashboard'
                }, 
                {
                    text: 'Request credit',
                    disabled: true,
                }
            ]
            this.$store.commit("backOffice/saveRecentRoute", path);
  }
    }
</script>
